import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AnnouncementNotificationService } from './announcement-modal.service';

export interface AnnouncementArticle {
  id?: number;
  title: string;
  content: string;
  annTypeName: string;
  publishTime: string;
}

@Component({
  selector: 'app-announcement-modal',
  templateUrl: './announcement-modal.component.html',
  styleUrls: ['./announcement-modal.component.scss'],
})
export class AnnouncementModalComponent implements OnInit {
  @Input() isModalVisible = false;
  @Output() isModalVisibleChange = new EventEmitter<boolean>();
  @Input() article?: AnnouncementArticle;

  constructor(private notificationService: AnnouncementNotificationService) {}

  ngOnInit(): void {}

  handlePreviewCancel(): void {
    this.isModalVisible = false;
    this.isModalVisibleChange.emit(false);
  }

  public show() {
    this.isModalVisible = true;
    this.isModalVisibleChange.emit(true);
  }

  onModalFullyVisible(): void {
    if (this.article) {
      this.notificationService.emit({ action: 'read', meta: { id: this.article?.id || -1 } });
    }
  }

  formatDate(date: string): string {
    const t = new Date(date);

    if (isNaN(t.getTime())) {
      return '';
    }

    const year = t.getFullYear();
    const month = t.getMonth() + 1;
    const day = t.getDate();
    const hours = String(t.getHours()).padStart(2, '0');
    const minutes = String(t.getMinutes()).padStart(2, '0');
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  }
}
